// module
import React from 'react';
import PropTypes from 'prop-types';

class DownloadLinks extends React.Component {
    render(){
        const {name, link} = this.props;

        if(!name){
            return (
                <label>
                    <a href={link}>
                        {link}</a>
                    <br />
                </label>
            );
            
        }else{
            return(
                <label>
                    &ensp;{name}&ensp; 
                    <a href={link}>
                        ({link})</a>
                    <br />
                </label>
            );
        }
    }
}

DownloadLinks.propTypes={
    name: PropTypes.string,
    link: PropTypes.string.isRequired
}

export default DownloadLinks;